import axiosInstance from "../axiosClient";
import { recording, updateRecordingStatus } from "../config";

export const getRecording = async (limit, name, start_key, email, id) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (email) queryParams.push(`email=${encodeURIComponent(email)}`);
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return await axiosInstance.get(`${recording}${queryString}`);
};

export const handle_Active_recording = async (data) => {
  return await axiosInstance.post(updateRecordingStatus, data);
};
